import 'whatwg-fetch';
import store from '../store';
import {loadingStart, loadingEnd} from '../uis/loading/httpLoading';
import {storage, SESSION_USER_INFO} from '../pages/sign/reducers/user';
import {HANDLE_OPEN} from '../uis/tip/reduces'
import dateFormat from './dateFormat'

export const GLOBAL_START = '/api';
export const NOT_LOGIN_CODE = -2;
export const SUCCESS_CODE = 0;

export function getUserInfo() {
    return JSON.parse(storage.getItem(SESSION_USER_INFO)) || {};
}
export function isRoot() {
    const user = getUserInfo().user || [];
    const roles = user.roles || []
    return !!roles.find((item) => item.name === '超级管理员')
}
export function isJuan() {
    const user = getUserInfo().user || [];
    return user.name === '廖宇娟';
}
export function isXi() {
    const user = getUserInfo().user || [];
    return user.name === '廖熙';
}
export function isShouQianRole() {
    const user = getUserInfo().user || [];
    const roles = user.roles || []
    return !!roles.find((item) => item.name === '售前')
}
export function isZhuGuanRole() {
    const user = getUserInfo().user || [];
    const roles = user.roles || []
    return !!roles.find((item) => item.name === '主管')
}
export function isShouHouRole() {
    const user = getUserInfo().user || [];
    const roles = user.roles || []
    return !!roles.find((item) => item.name === '售后')
}
export function isTechShouHouRole() {
    const user = getUserInfo().user || [];
    const roles = user.roles || []
    return !!roles.find((item) => item.name === '自建系统售后')
}
export function isOnlyTechRole() {
    const user = getUserInfo().user || [];
    const roles = user.roles || []
    return !!roles.find((item) => item.name === '技术')
}
export function isTechRole() {
    const user = getUserInfo().user || [];
    const roles = user.roles || []
    return !!roles.find((item) => item.name === '技术' || item.name === '仿站技术主管')
}
export function isTechManagerRole() {
    const user = getUserInfo().user || [];
    const roles = user.roles || []
    return !!roles.find((item) => item.name === '仿站技术主管')
}
export function isFPGroupRole() {
    const user = getUserInfo().user || [];
    const roles = user.roles || []
    return !!roles.find((item) => (item.name === '配音开票管理员' || item.name === '超级管理员'))
}
export function isSuixiRole() {
    const user = getUserInfo().user || [];
    const roles = user.roles || []
    return !!roles.find((item) => item.name === '遂溪配音开票员')
}
export function isHeishiRole() {
    const user = getUserInfo().user || [];
    const roles = user.roles || []
    return !!roles.find((item) => item.name === '黑石配音开票员')
}
export function isDouquRole() {
    const user = getUserInfo().user || [];
    const roles = user.roles || []
    return !!roles.find((item) => item.name === '都去配音开票员')
}
export function isTaozhiRole() {
    const user = getUserInfo().user || [];
    const roles = user.roles || []
    return !!roles.find((item) => item.name === '淘知配音开票员')
}

export function getShouqianJiaofuxinxi(row) {
    return `亲，您的网站初稿已完成，这是您的网站后台信息，方便您后续管理网站的：\n后台登陆地址: ${row.customerAdminUrl}\n后台用户名: ${row.customerAdminName}\n后台密码: ${row.customerAdminPassword}\n预览网站，登陆管理后台点击右上角预览即可。\n后台操作教程：http://www.kaixinjianzhan.com/\n\n\n您这边有空的时候看下网站效果。\n把需要修改的地方告诉网站对接专员，专员这边安排给您调整，网站上的图片，文字都可以替换\n如果问题比较多的话，您这边可以整理成文档发给专员，文档怎么写，您可以看下面这个链接：\nhttp://www.kaixinjianzhan.com/article_2689.html\n\n\n等您网站确定没有问题后，就找专员，他会安排给您绑定域名上线。`
}

export function getMyShouqianJiaofuxinxi(row) {
    return `亲，您的网站初稿已完成，这是您的网站后台信息，方便您后续管理网站的：\n后台登陆地址: ${row.customerAdminUrl}\n后台用户名: ${row.customerAdminName}\n后台密码: ${row.customerAdminPassword}\n预览网站，登陆管理后台点击右上角预览即可。\n后台操作教程：http://www.kaixinjianzhan.com/\n\n\n您的网站已经达到上线标准，我这边给您注册域名（公司简称拼音.top）绑定上线，您确认下给我答复，我这边立即安排处理。`
}

export function getDuijieJiaofuxinxi(row) {
    return `亲，您的网站初稿已完成，这是您的网站后台信息，方便您后续管理网站的：\n后台登陆地址: ${row.customerAdminUrl}\n后台用户名: ${row.customerAdminName}\n后台密码: ${row.customerAdminPassword}\n预览网站，登陆管理后台点击右上角预览即可。\n后台操作教程：http://www.kaixinjianzhan.com/\n\n\n您这边有空的时候看下网站效果。\n把需要修改的地方告诉我，我这边安排给您调整，网站上的图片，文字都可以替换\n如果问题比较多的话，您这边可以整理成文档发给我，文档怎么写，您可以看下面这个链接：\nhttp://www.kaixinjianzhan.com/article_2689.html\n\n\n等您网站确定没有问题后，就找我，我会安排给您绑定域名上线。`
}

export function getDuijieTiGongZiLiao(row) {
    return `您好，需要您那边提供一下资料，这个是资料清单（点开链接填写保存）：\n http://www.kaixinjianzhan.com/a/?name=${row.customerAdminName}${(row.orderType && row.orderType !== '展示') ? '&type=pay' : ''}\n\n基本信息填写即可，产品新闻请点击下载：其他资料打包格式\n\n其他资料准备好后，打包发给我。`;
}

export function getDuijieJiaoFuRiQi(row) {
    const date = new Date(row.sendEmailTime);
    date.setDate(date.getDate() + 1);
    return `您好，您的资料已经提交给开发部开发，预计开发完交付初稿时间为${dateFormat(date, 'yyyy-MM-dd')}。（周六周日未计算在工作日内）`;
}
function getUrl(api) {
    if (api.indexOf('/njs') === 0 || api.indexOf('http') === 0) {
        return api;
    }
    return GLOBAL_START + api;
}

export function parseResponse(response) {
    try {
        console.info(response.status);
        if (response.status >= 200 && response.status < 600) {
            const json = response.json();
            return json.then(res => {
                if (res.status === SUCCESS_CODE) {
                    return Promise.resolve(res);
                }
                store.dispatch({type: HANDLE_OPEN,variant: 'error',message: res.message})
                if (res.status === NOT_LOGIN_CODE) {
                    setTimeout(()=>{
                        window.location.href='/sign/sign-in'            
                    }, 1500)
                }
                return Promise.reject(res);
            });
        }
        store.dispatch({type: HANDLE_OPEN,variant: 'error',message: `调用接口报错: ${response.statusText}`})
        return Promise.reject(response.statusText)
    } catch(e) {
        store.dispatch({type: HANDLE_OPEN,variant: 'error',message: e.message})
    }
}

function getFn(api) {
    const {token} = getUserInfo();
    return fetch(getUrl(api), {
        headers: {
            "Cache-Control": "no-cache",
            "Accept": "application/json",
            "Content-Type": "application/json",
            token,
        },
        credentials: 'include',
    })
}
export function get(api) {
    return loadingStart()
                .then(() => {
                    return getFn(api);
                })
                .then((res)=>{
                    loadingEnd();
                    return parseResponse(res)
                })
}

function postFn(api, body) {
    const {token} = getUserInfo();
    return fetch(getUrl(api), {
        headers: {
            "Cache-Control": "no-cache",
            "Accept": "application/json",
            "Content-Type": "application/json",
            token
        },
        credentials: 'include',
        method: "post",
        body: JSON.stringify(body)
    })
}
export function post(api, body) {
    return loadingStart()
        .then(() => {
            return postFn(api, body);
        })
        .then((res)=>{
            loadingEnd();
            return parseResponse(res)
        })
}

const saveData = (function () {
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("style", "display: none"); 
    return (blob, fileName) => {
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        console.info(url);
        window.URL.revokeObjectURL(url);
    };
}())

export function download(api,filename, isPost = false, body) {
    return loadingStart()
        .then(() => {
            return !isPost ? getFn(api) : postFn(api, body);
        })
        .then((res)=>{
            return res;
        })
        .then((res) => {
            console.log(res)
            return res.blob();
        })
        .then((blob)=>{
            loadingEnd();
            console.info(blob)
            saveData(blob, filename)
        })
}


// WEBPACK FOOTER //
// ./src/util/http.js